import { useState } from 'react';

function recordingIdentity(value: string | null): string | null {
  if (!value) return value;
  try {
    const url = new URL(value);
    // Only ignore rotating Azure SAS credentials; retain query parameters that
    // may select a different recording version or playback variant.
    if (url.searchParams.has('sig') && url.searchParams.has('se')) {
      for (const key of ['sig', 'se', 'st']) url.searchParams.delete(key);
      url.searchParams.sort();
      return url.toString();
    }
  } catch {
    // Relative/provider URLs keep exact identity.
  }
  return value;
}

function isExpired(value: string | null): boolean {
  if (!value) return false;
  try {
    const expiresAt = new URL(value).searchParams.get('se');
    return expiresAt !== null && Date.parse(expiresAt) <= Date.now();
  } catch {
    return false;
  }
}

export function useStableRecordingUrl(incoming: string | null, isPlaying: boolean): string | null {
  const [retained, setRetained] = useState(incoming);
  if (
    incoming !== retained &&
    (recordingIdentity(incoming) !== recordingIdentity(retained) ||
      (!isPlaying && isExpired(retained)))
  ) {
    // Update during render so a genuinely new asset is never rendered with the
    // previous source. Renew expired credentials only when playback is idle.
    setRetained(incoming);
    return incoming;
  }
  return retained;
}
